document.addEventListener("DOMContentLoaded", function() {
    const adjustTitle = () => {
        const titleElement = document.querySelector('.shopify-buy__product__title');
        
        if (titleElement && titleElement.textContent.includes('(')) {
            // Store the current text content
            const text = titleElement.textContent;
            
            // Replace and wrap content between parentheses
            const adjustedText = text.replace(/\(([^)]+)\)/, '<br><span class="title-adjuster">($1)</span>');
            
            // Apply the adjusted HTML
            titleElement.innerHTML = adjustedText;
            
            // Stop the interval once adjustment is done
            clearInterval(titleCheck);
        }
    };

    // Check every 500ms until the title is found and adjusted
    const titleCheck = setInterval(adjustTitle, 500);
});